import { notification } from 'antd'
import { useQuery } from 'react-query'

import { Batch, BillingBatchFilters } from '@types'

import sortBySetter from '../../utils/sort-by-setter'
import { getBillingBatch } from './api'

const onError = () => {
  notification.error({
    message: 'Error al obtener los lotes',
  })
}

const useGetBatchees = (filters?: BillingBatchFilters) => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: ['billing-batch', filters],
    queryFn: () => getBillingBatch({ filters }),
    onError,
    refetchOnWindowFocus: false,
  })

  return {
    billingBatch: data ? (data.sort(sortBySetter('id', true)) as Batch[]) : ([] as Batch[]),
    isLoading,
    loadBatchees: refetch,
  }
}

export { useGetBatchees }
